import React from "react";
import { FaPlus, FaTrash, FaTimes } from "react-icons/fa";
import styles from "./SubCategoryModal.module.css";

export default function SubCategoryModal({
  subCat,
  items,
  onAdd,
  onRemove,
  onChange,
  onFileUpload,
  onSave,
  onCancel
}) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        
        {/* HEADER */}
        <div className={styles.modalHeader}>
          <h2>Edit {subCat}</h2>
          <button className={styles.closeBtn} onClick={onCancel}>
            <FaTimes />
          </button>
        </div>

        {/* ITEMS */}
        <div className={styles.itemsContainer}>
          {items.map((item, i) => (
            <div key={i} className={styles.itemRow}>
              <input
                type="text"
                placeholder="Name"
                value={item.name || ""}
                onChange={(e) =>
                  onChange(subCat, i, { ...item, name: e.target.value })
                }
                className={styles.input}
              />

              <input
                type="number"
                placeholder="Amount"
                value={item.amount}
                onChange={(e) =>
                  onChange(subCat, i, {
                    ...item,
                    amount: Number(e.target.value),
                  })
                }
                className={styles.input}
              />

              <input
                type="text"
                placeholder="Note"
                value={item.note || ""}
                onChange={(e) =>
                  onChange(subCat, i, { ...item, note: e.target.value })
                }
                className={styles.input}
              />

              <input
                type="file"
                onChange={(e) =>
                  onFileUpload(subCat, i, e.target.files[0])
                }
                className={styles.inputFile}
              />

              <button
                className={styles.deleteBtn}
                onClick={() => onRemove(subCat, i)}
              >
                <FaTrash />
              </button>
            </div>
          ))}
        </div>

        {/* ADD BUTTON */}
        <button className={styles.addBtn} onClick={() => onAdd(subCat)}>
          <FaPlus /> Add Item
        </button>

        {/* FOOTER BUTTONS */}
        <div className={styles.footer}>
          <button className={styles.saveBtn} onClick={onSave}>
            Save
          </button>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
